/**
 * Matches inventory against a punctuation-insensitive, word-order independent query.
 * @param search Search text entered by the agent
 * @param values Searchable inventory fields
 */
export const matchesInventorySearch = (search: string, values: Array<string | undefined | null>): boolean => {
  const searchTokens = search.toLocaleLowerCase().match(/[\p{L}\p{N}]+/gu) || [];

  if (searchTokens.length === 0) {
    return true;
  }

  const searchableText = values
    .filter((value): value is string => Boolean(value))
    .join(" ")
    .toLocaleLowerCase();

  return searchTokens.every((token) => searchableText.includes(token));
};
